import { _,Radio,Backbone,$,Foundation,moment } from '../../../vendor'
import { Backform,Notification,Biscuit } from '../../utils'
import OffCanvasBehavior from '../../behaviors/Behavior.OffCanvas'
import InboomaBaseView from '../InboomaBaseView'

import Prices from '../../collections/Prices'
import Pricetariff from '../../models/Pricetariff'
import PricetariffFormModalTpl from '../../templates/contingents/PricetariffFormModalTpl.html'
import { appRollingLoaderAnim } from '../AppAnnouncements'

export default InboomaBaseView.extend({

  template : PricetariffFormModalTpl,
  el: '#inb-price-edit-modal',
  form : [],

  events : {
    'click .remove-price' : '_removePrice',
    'click .tabs-title a' : '_toggleActivePricetariff',
  },

  options : {
    routeBack: 'pricetariffs',
    hasMultiplePricetariffs: false
  },

  templateContext () {
    return {
      collection: this.collection,
      moment,
      hasMultiplePricetariffs: this.getOption('hasMultiplePricetariffs'),
      Prices // required!
    }
  },

  _setPricetariffForm () {

    const that = this;

    let pricetariff = this.model;

    if (pricetariff.get('prices').models[0].get('pricetype_id') != '') {
        pricetariff.set('pricetype_id', pricetariff.get('prices').models[0].get('pricetype_id'));
    }

    let pricetypes = [];
    
    // Map through "official" pricetypes, select only
    // those which are actually functional
    _.each(this.pricetypes.models, (pricetype) => {
      if (typeof pricetype !== 'undefined' && (
          pricetype.get('id') == 2 ||
          pricetype.get('id') == 3 ||
          pricetype.get('id') == 8 ||
          pricetype.get('id') == 11 ||
          pricetype.get('id') == 16 ||
          pricetype.get('id') == 19 ||
          pricetype.get('id') == 25 ||
          pricetype.get('id') == 24 ||
          pricetype.get('id') == 26 ||
          pricetype.get('id') == 27 ||
          pricetype.get('id') == 28 ||
          pricetype.get('id') == 29)) {
          pricetypes.push(
            {
              label : pricetype.get('name') + ' (' + pricetype.get('description') + ')',
              value : pricetype.get('id')
            }
          );
      }
    });
    let time_rates = [
      { label : this.t('minutes',null,'capital'), value : 60 },
      { label : this.t('hours',null,'capital'), value : 3600 },
      { label : this.t('days',null,'capital'), value : 86400 },
    ];

    const form = new Backform.Form({

      el : this.$el.find('form'),
      model : this.model,
      fields : [
        {
          name : "name",
          label : this.t('name',null,'capital'),
          required : true,
          control: "input",
          size : {
            "large" : "5"
          }
        },{
          name : "pricetype_id", // We'll attach it later to price-model
          control : "select",
          label : this.t('pricetype',null,'capital'),
          required : true,
          options : pricetypes,
          size : {
            "large" : "7"
          }
        },{
          name : "description",
          label : this.t('description',null,'capital'),
          control : "input",
          size : {
            "large" : "5"
          }
        },{
          name : "contingents",
          label : this.t('contingents',null,'capital'),
          control : "selector",
          disabled: this.getOption('hasMultiplePricetariffs'),
          hasMultiple : () => 999,
          options : _.map(this.contingents.models, (contingent) => {
            return { label: contingent.get('name'), value: contingent.get('id') }
          }),
          size : {
            "large" : "7"
          }
        },{
          name : "begin",
          label : this.t('start',null,'capital'),
          required : true,
          control : "datepicker",
          size : {
            "large" : "6"
          },
          helpMessage : this.t('prices_begin_info')
        },{
          name : "end",
          label : this.t('end',null,'capital'),
          required : true,
          control : "datepicker",
          size : {
            "large" : "6"
          },
          helpMessage : this.t('prices_end_info')
        },{
          name : "_duration",
          label :  this.t('duration',null,'capital'),
          control : "uneditable-input",
          size : {
            "large" : "12"
          }
        },{
          name : "_amount",
          label: this.t('count_units',null,'capital'),
          control : "input",
          size : {
            "large" : "2"
          },
        }, {
          name: "_rate",
          label: this.t('units', null, 'capital'),
          control: "select",
          options: time_rates,
          size: {
            "large": "4"
          }
        }, {
          label : this.t('save',null,'capital'),
          control : "button",
          extraTopClasses : ['button-submit-wrapper'],
          extraClasses : ['expanded button-submit'],
          size : {
            "large" : "12"
          }
        }
      ],
      events : {
        "click .button-submit" : (ev) => {

          ev.preventDefault();

          that.model.set('duration', parseInt(that.model.get('_amount')));

          if (that.model.get('duration') != 0 && that.model.get('duration') != '' && !_.isNaN(that.model.get('duration'))) {
            that.model.set('duration',(parseInt(that.model.get('_amount')) * parseInt(that.model.get('_rate'))));
          }
          delete that.model.attributes._amount;
          delete that.model.attributes._rate;

          $(this.$el.find('form')).foundation('validateForm');

          if (pricetariff.isValid() && !this.$el.find('form .is-invalid-input').length) {

            if (pricetariff.get('prices').models[0].attributes.amount == '') {
              if (pricetariff.get('prices').models[0].attributes.amount_weekday_1 == '' ||
                  pricetariff.get('prices').models[0].attributes.amount_weekday_2 == '' ||
                  pricetariff.get('prices').models[0].attributes.amount_weekday_3 == '' ||
                  pricetariff.get('prices').models[0].attributes.amount_weekday_4 == '' || 
                  pricetariff.get('prices').models[0].attributes.amount_weekday_5 == '' ||
                  pricetariff.get('prices').models[0].attributes.amount_weekday_6 == '' ||
                  pricetariff.get('prices').models[0].attributes.amount_weekday_7 == '') {
                    // Some days have been left open...
                    // @todo i18n
                    if (!confirm(that.t('warning_prices_not_complete'))) {
                      return false;
                    }
                }
            }

            that.$el.find('.button-submit-wrapper .button')
                    .html(appRollingLoaderAnim);

            pricetariff = OffCanvasBehavior.prototype.normalizeModel(pricetariff);
            
            _.each(pricetariff.get('prices').models, (price) => {
                price.set('pricetype_id', pricetariff.get('pricetype_id'));
            });

            const _prices = pricetariff.get('prices');
            delete pricetariff.attributes.prices;

            // Ensure pricetariff.contingents[] only contains ids,
            const _contingents = [];

            _.each(pricetariff.get('contingents'), (contingent) => {
              _contingents.push({ id : contingent.id })
            });

            pricetariff.set('contingents', _contingents)
            pricetariff.set('client_id', Number(Biscuit.get('user.client_id')));
 
            const isNew = (pricetariff.get('id') == '' || pricetariff.get('id') == null);

            pricetariff.save(null, {

              success (model, response, options) {

                pricetariff = new Pricetariff(response.data);
                pricetariff.set('prices', _prices);

                new Notification({
                  message : that.t((isNew ? 'saved_${a}' : 'updated_${a}'),{a:that.t('pricetariff')},'capital'),
                  duration : 5000,
                  type : 'success',
                  closeable : true,
                  icon : 'fi fi-pricetag-multiple'
                });

                // !that.collection may be the global pricetariffs collection OR contingent.pricetariffs!
                that.collection.set(pricetariff, { add : true, merge : true,  remove: false});

                // To avoid side-posting, we have to put price(s)
                // piece by piece. this refs #18870

                // @todo OUTDATED - Kolja changed save strategy of pricetariff.prices to "replace"
                // at 25.05.19; removing the surrounding lines accordingly when coming back here
                // at 10.07.19; NO HE DIDN'T - passing prices to pricetariff-endpoint still does not work
                _.each(pricetariff.get('prices').models, (_price) => {
                  
                  _price.save({
                    pricetariff_id : pricetariff.get('id')
                  },{
                    type: (_price.get('id') == '' ? 'POST' : 'PATCH'),
                    success () {
                    },
                    error () {
                    }
                  })

                });

                if (that.getOption('hasMultiplePricetariffs')) {

                  // Force refetch of pricetariff on global collection so that the new/edited
                  // pricetariff becomes available in PricetariffsList and ReservationForm
                  Radio.channel('pricetariffs')
                       .request('get:data')
                       .fetchById(pricetariff.get('id'), _.noop, true);

                }

                that.pricesModal.close();

              }, error (model, xhr, options) {

                new Notification({
                  message : that.t('request_error'),
                  duration : 5000,
                  type : 'warning',
                  closeable : true,
                  icon : 'fi fi-x'
                });
              }
            });
          }

          return false;

        }
      }
    }).render();

    new Foundation.Abide(this.$el.find('form'), { liveValidate:true });

  },

  _toggleActivePricetariff (el) {

    const id = el.currentTarget.getAttribute('data-id');
    
    this.model = this.collection.get((id === '' ? '' : Number(id)));
    this._render();    

  },

  _render () {

    const that = this;

    // Ensure that we always have a complete model in scope
    if (this.model.get('id') !== '') {
      this.model.fetch({
        success () {
          that.model.initialize(); // Set pricetariffs.prices as Backbone.Model
          that.render();
        }
      })
    } else {
      this.render();
    }
  },

  initialize () {

    this.contingents = this.getOption('contingents');
    this.pricetypes = this.getOption('pricetypes');

    this.pricesModal = new Foundation.Reveal(this.$el);
    this._render();

    this.pricesModal.open();

  },

  onRender () {

    const that = this;
    
    this._setPricetariffForm();

      // Move prices-table and add events to it
      this.$el.find('.pricesFormTable')
              .insertBefore(this.$el.find('form .button-submit-wrapper'));
      
      this.$el.find('form .pricesFormTable input').on('keyup', function (target) {
        
        // Only allow numeric chars or ',' for prices
        let val = $(this).val();

        if (isNaN(val)) {
            val = val.replace(/[^0-9\,]/g,'');
            if (val.split(',').length > 2) { 
              val = val.replace(/\,+$/,"");
            }
        }

        $(this).val(val);

      });

      this.$el.find('form .pricesFormTable input').on('focusout', function(target) {

        target.preventDefault();
        let val = $(this).val();

        // To remove leading zeros: "014".replace(/^0+/, '')

        // Who the hell needs two-way data-binding? #muhahahaha
        if ($(this).hasClass('is-standard-amount')) {

          that.$el.find('form .pricesFormTable input')
                   .not('.is-standard-amount')
                   .each(function() {
                     
              if (val == '') {

                $(this).removeProp('disabled');

              } else {

                $(this).val('');

                if (String(val).indexOf(',') < 0) {
                  val += ',00';
                  that.$el.find('form .pricesFormTable input.is-standard-amount').val(val);
                } 

                that.model.get('prices').models[0]
                           .unsetWeekdayAmounts()
                           .set('amount', val);
        
                $(this).attr('disabled', 'disabled');
              }
          });

        } else {

          const weekday = $(this).attr('name');

          if (Number(weekday) >= 1 && Number(weekday) <= 7) {
            if (val.length >= 1) {

              that.$el.find('form .pricesFormTable input.is-standard-amount').val('');
              that.model.get('prices').models[0].set('amount','');
              
              if (String(val).indexOf(',') < 0) {
                val += ',00';
                $(this).val(val);
              }
            }

            that.model.get('prices').models[0].set('amount_weekday_' + weekday, val);
          }
        }

    });

    this.$el.on('closed.zf.reveal', () => {
      // Remove that.$el from DOM
      that.unbind();
      that.$el.html('');
      Backbone.history.navigate(that.getOption('routeBack'), { trigger:true });
      that.$el.off('closed.zf.reveal');
    });

  }

});